/**
* @file 公共组件-横向滚动
* */
<template>
  <div id="custom-across-roll">
    <div class="custom-date" :class="{ 'prev-next': showArrow }">
      <div class="nav-prev" v-if="showArrow" @click="navPrev">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="nav-next" v-if="showArrow" @click="navNext">
        <i class="el-icon-arrow-right"></i>
      </div>
      <div id="dateGroupList" class="date-group" ref="dateGroupList">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-across-roll",
  data() {
    return {
      // 是否显示前后箭头
    }
  },
  props:{
    showArrow:{
      default() {
        return true;
      },
    }
  },
  methods: {
    /**
     * 点击左箭头 - iOS 26 平滑滚动
     */
    navPrev() {
      const el = this.$refs.dateGroupList;
      if (el) {
        el.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      }
    },
    /**
     * 点击右箭头 - iOS 26 平滑滚动
     */
    navNext() {
      const el = this.$refs.dateGroupList;
      if (el) {
        el.scrollTo({
          left: el.scrollWidth,
          behavior: 'smooth'
        });
      }
    },
  },
}
</script>

<style lang="less">
#custom-across-roll {
  width: 100%;

  .custom-date {
    width: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    
    // iOS 26 箭头按钮样式
    .nav-prev,
    .nav-next {
      position: absolute;
      cursor: pointer;
      width: 28px;
      height: 28px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.9);
      border: 1px solid rgba(0, 0, 0, 0.06);
      // iOS 26 柔和阴影
      box-shadow: 
        0 1px 3px rgba(0, 0, 0, 0.06),
        0 2px 8px rgba(0, 0, 0, 0.04);
      font-size: 14px;
      color: rgba(60, 60, 67, 0.6);
      z-index: 10;
      // 流畅弹性动画
      transition: 
        transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        box-shadow 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        color 0.25s ease,
        background 0.25s ease;

      &:hover {
        color: @color-primary;
        background: rgba(255, 255, 255, 1);
        box-shadow: 
          0 2px 6px rgba(0, 0, 0, 0.08),
          0 4px 12px rgba(0, 0, 0, 0.06);
        transform: scale(1.05);
      }
      
      &:active {
        transform: scale(0.95);
        transition-duration: 0.1s;
      }
    }
    
    .nav-prev {
      left: 0;
    }

    .nav-next {
      right: 0;
    }
  }

  .custom-date.prev-next {
    padding: 0 36px;
    box-sizing: border-box;
  }

  // iOS 26 滚动容器样式
  .date-group {
    flex-shrink: 0;
    width: 100%;
    padding-top: 6px;
    padding-bottom: 6px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    // iOS 平滑滚动
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    // 隐藏滚动条但保持功能
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  // iOS 26 日期项样式
  .date {
    line-height: 32px;
    padding: 0 16px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    flex-shrink: 0;
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    overflow-x: hidden;
    background: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    font-weight: 500;
    color: @color-text-primary;
    // iOS 26 柔和阴影
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    // 流畅弹性动画
    transition: 
      transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
      border-color 0.25s ease,
      color 0.25s ease,
      background 0.25s ease,
      box-shadow 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    .date-close {
      width: 0;
      opacity: 0;
      font-size: 16px;
      margin-left: 0;
      transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      visibility: hidden;
    }

    .date-close.remove {
      width: 12px;
      opacity: 1;
      margin-left: 12px;
      visibility: initial;
    }

    &:hover {
      border-color: fade(@color-primary, 40%);
      color: @color-primary;
      transform: translateY(-1px);
      box-shadow: 
        0 2px 6px rgba(0, 0, 0, 0.06),
        0 0 0 2px fade(@color-primary, 8%);
    }
    
    &:active {
      transform: translateY(0) scale(0.98);
      transition-duration: 0.1s;
    }
  }

  // iOS 26 激活状态
  .date.active {
    border-color: @color-primary;
    background: @color-primary;
    color: #fff;
    box-shadow: 
      0 2px 8px fade(@color-primary, 30%),
      0 4px 12px fade(@color-primary, 20%);
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 
        0 4px 12px fade(@color-primary, 35%),
        0 6px 16px fade(@color-primary, 25%);
    }
  }
}

// iOS 26 滚动条样式
#custom-across-roll {
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    // 流畅动画
    transition: background 0.3s ease;
    
    &:hover {
      background: rgba(0, 0, 0, 0.2);
    }
  }
  
  // 鼠标悬停时显示滚动条
  .date-group:hover {
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.18);
    }
  }
}


</style>
